/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum LocatorBankDataAliases {
  BUTTON_SELECT = 'button-select',
  CONTEXTUAL_BAR_PROCEDURE = 'contextual-bar-Procedure',
  FETCH_BANK = 'fetch-bank',
  FIELD_BANK = 'field-bank',
  FIELD_BANK_CODE = 'field-bank-code',
  FILTER_PROCEDURE = 'filter-procedure',
  FILTERED_LIST_PROCEDURES = 'filtered-list-procedures',
  INPUT_BANK = 'input-bank',
  INPUT_BANK_CODE = 'input-bank-code',
  PAGINATOR_0 = 'paginator-0',
  PANEL_1 = 'panel-1',
  PANEL_LOCATOR_BANK = 'panel-locator-bank',
  PANEL_PAGINATOR = 'panel-paginator',
  TABLE_BANK = 'table-bank',
  TABLE_COLUMN_0 = 'table-column-0',
  TABLE_COLUMN_1 = 'table-column-1',
}
export { LocatorBankDataAliases };
